import { useCallback, useMemo, useState } from 'react'

const STORAGE_KEY = 'corsalia.mapTracesVisible'

/**
 * Affichage des tracés de missions sur la carte (lignes SVG des flottes en vol),
 * état purement front persisté en localStorage. **Défaut : visible** (`true`) —
 * un toggle dans `MapControls` permet de les masquer. Pattern miroir de
 * `useMapTypeFilter`/`useViewMode` (try/catch safe en navigation privée).
 */
export interface TraceVisibility {
  /** Les tracés de missions sont-ils affichés ? */
  visible: boolean
  /** Bascule l'affichage des tracés et persiste le choix. */
  toggle: () => void
}

export function useTraceVisibility(): TraceVisibility {
  const [visible, setVisible] = useState<boolean>(() => {
    try {
      // '0' = masqué persisté ; tout le reste (dont l'absence de clé) = visible.
      return localStorage.getItem(STORAGE_KEY) !== '0'
    } catch {
      return true
    }
  })

  const toggle = useCallback(() => {
    setVisible((prev) => {
      const next = !prev
      try {
        localStorage.setItem(STORAGE_KEY, next ? '1' : '0')
      } catch {
        /* localStorage unavailable (private mode) — keep the in-memory choice */
      }
      return next
    })
  }, [])

  return useMemo(() => ({ visible, toggle }), [visible, toggle])
}
